import {
  NormalBrowseFileInputFiled,
  NormalMultipleFixedInputFields,
  NormalTextInputField,
  RepeatableMultipleInputStackFilds,
} from "@/components";
import { useMemo } from "react";

const ContactUsCMSForm = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  addMultiValueRepeaterChange,
  removeMultiValueRepeaterChange,
  updateMultiValueRepeaterChange,
  handleImageChange,
  adminRole,
  permissionsList,
  colorGrade,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {/* Hero Section */}
      {selectedTab === "section-1" && (
        <>
          {/* Banner Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Banner Image"
              fieldId="contact-us-banner-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange("contact-us-banner-image", id)
                  : handleImageChange("contact-us-banner-image", "")
              }
              selectedFileId={formData?.["contact-us-banner-image"] || ""}
              adminRole={adminRole}
              permissionsList={permissionsList}
              infoText="Recommended size: 1300 x 650px"
            />
          )}

          {/* Banner Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Banner Heading"
            fieldId="contact-us-banner-heading"
            fieldName="contact-us-banner-heading"
            placeholderText="Heading"
            inputValue={formData?.["contact-us-banner-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Banner Sub Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Banner Description"
            fieldId="contact-us-banner-description"
            fieldName="contact-us-banner-description"
            placeholderText="Description"
            inputValue={formData?.["contact-us-banner-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />
        </>
      )}
      {/* Map Section */}
      {selectedTab === "section-2" && (
        <>
          {/* Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Heading"
            fieldId="contact-us-map-heading"
            fieldName="contact-us-map-heading"
            placeholderText="Heading"
            inputValue={formData?.["contact-us-map-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Description"
            fieldId="contact-us-map-description"
            fieldName="contact-us-map-description"
            placeholderText="Description"
            inputValue={formData?.["contact-us-map-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Latitude */}
          {isHideInOtherLanguages && (
            <NormalTextInputField
              isFetching={isFetching}
              labelText="Latitude"
              fieldId="contact-us-map-latitude"
              fieldName="contact-us-map-latitude"
              placeholderText="Latitude"
              inputValue={formData?.["contact-us-map-latitude"] || ""}
              onChangeTextInputField={handleTextInputChange}
              translateField={false}
              extraContainerClasses="mt-5"
              extraFiledInfo="Please enter the latitude value."
            />
          )}

          {/* Longitude */}
          {isHideInOtherLanguages && (
            <NormalTextInputField
              isFetching={isFetching}
              labelText="Longitude"
              fieldId="contact-us-map-longitude"
              fieldName="contact-us-map-longitude"
              placeholderText="Longitude"
              inputValue={formData?.["contact-us-map-longitude"] || ""}
              onChangeTextInputField={handleTextInputChange}
              translateField={false}
              extraContainerClasses="mt-5"
              extraFiledInfo="Please enter the longitude value."
            />
          )}

          {/* Contact Options */}
          <NormalMultipleFixedInputFields
            stateDetails={formData}
            isFetching={isFetching}
            allFilesResponse={allFilesResponse}
            labelText="Contact Options"
            fieldId="contact-us-map-options"
            searchValue={searchValue}
            selectedFileType={selectedFileType}
            adminRole={adminRole}
            permissionsList={permissionsList}
            handleImageChange={handleImageChange}
            handleTextInputChange={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
            cards={[
              {
                card_id: "contact-us-map-options-card-1",
                types: ["TEXT", "TEXT", "TEXT"],
                is_hidden: [
                  true,
                  isHideInOtherLanguages,
                  isHideInOtherLanguages,
                ],
                ids_name: [
                  "text_filed_id_1",
                  "text_filed_id_2",
                  "text_filed_id_3",
                ],
                placeholders_name: [
                  "text_filed_placeholder_1",
                  "text_filed_placeholder_2",
                  "text_filed_placeholder_3",
                ],
                // IDs
                text_filed_id_1: "contact-us-map-options-title-1",
                text_filed_id_2: "contact-us-map-options-value-one-1",
                text_filed_id_3: "contact-us-map-options-value-two-1",
                // Placeholders
                text_filed_placeholder_1: "Title 1",
                text_filed_placeholder_2: "Value Option One 1",
                text_filed_placeholder_3: "Value Option Two 1",
              },
              {
                card_id: "contact-us-map-options-card-2",
                types: ["TEXT", "TEXT", "TEXT"],
                is_hidden: [
                  true,
                  isHideInOtherLanguages,
                  isHideInOtherLanguages,
                ],
                ids_name: [
                  "text_filed_id_1",
                  "text_filed_id_2",
                  "text_filed_id_3",
                ],
                placeholders_name: [
                  "text_filed_placeholder_1",
                  "text_filed_placeholder_2",
                  "text_filed_placeholder_3",
                ],
                // IDs
                text_filed_id_1: "contact-us-map-options-title-2",
                text_filed_id_2: "contact-us-map-options-value-one-2",
                text_filed_id_3: "contact-us-map-options-value-two-2",
                // Placeholders
                text_filed_placeholder_1: "Title 2",
                text_filed_placeholder_2: "Value Option One 2",
                text_filed_placeholder_3: "Value Option Two 2",
              },
              {
                card_id: "contact-us-map-options-card-3",
                types: ["TEXT", "TEXT", "TEXT"],
                is_hidden: [
                  true,
                  isHideInOtherLanguages,
                  isHideInOtherLanguages,
                ],
                ids_name: [
                  "text_filed_id_1",
                  "text_filed_id_2",
                  "text_filed_id_3",
                ],
                placeholders_name: [
                  "text_filed_placeholder_1",
                  "text_filed_placeholder_2",
                  "text_filed_placeholder_3",
                ],
                // IDs
                text_filed_id_1: "contact-us-map-options-title-3",
                text_filed_id_2: "contact-us-map-options-value-one-3",
                text_filed_id_3: "contact-us-map-options-value-two-3",
                // Placeholders
                text_filed_placeholder_1: "Title 3",
                text_filed_placeholder_2: "Value Option One 3",
                text_filed_placeholder_3: "Value Option Two 3",
              },
              {
                card_id: "contact-us-map-options-card-4",
                types: ["TEXT", "TEXT", "TEXT"],
                is_hidden: [
                  true,
                  isHideInOtherLanguages,
                  isHideInOtherLanguages,
                ],
                ids_name: [
                  "text_filed_id_1",
                  "text_filed_id_2",
                  "text_filed_id_3",
                ],
                placeholders_name: [
                  "text_filed_placeholder_1",
                  "text_filed_placeholder_2",
                  "text_filed_placeholder_3",
                ],
                // IDs
                text_filed_id_1: "contact-us-map-options-title-4",
                text_filed_id_2: "contact-us-map-options-value-one-4",
                text_filed_id_3: "contact-us-map-options-value-two-4",
                // Placeholders
                text_filed_placeholder_1: "Title 4",
                text_filed_placeholder_2: "Value Option One 4",
                text_filed_placeholder_3: "Value Option Two 4",
              },
            ]}
          />
        </>
      )}
      {/* Form Section */}
      {selectedTab === "section-3" && (
        <>
          {/* Form Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Form Image"
              fieldId="contact-us-form-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange("contact-us-form-image", id)
                  : handleImageChange("contact-us-form-image", "")
              }
              selectedFileId={formData?.["contact-us-form-image"] || ""}
              adminRole={adminRole}
              permissionsList={permissionsList}
            />
          )}

          {/* Form Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Form Heading"
            fieldId="contact-us-form-heading"
            fieldName="contact-us-form-heading"
            placeholderText="Form Heading"
            inputValue={formData?.["contact-us-form-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Form Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Form Description"
            fieldId="contact-us-form-description"
            fieldName="contact-us-form-description"
            placeholderText="Form Description"
            inputValue={formData?.["contact-us-form-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Form Button Label */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Form Button Label"
            fieldId="contact-us-form-button-label"
            fieldName="contact-us-form-button-label"
            placeholderText="Form Button Label"
            inputValue={formData?.["contact-us-form-button-label"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />
        </>
      )}
      {/* Agents Section */}
      {selectedTab === "section-4" && (
        <>
          {/* Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Heading"
            fieldId="contact-us-agents-heading"
            fieldName="contact-us-agents-heading"
            placeholderText="Heading"
            inputValue={formData?.["contact-us-agents-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Description"
            fieldId="contact-us-agents-description"
            fieldName="contact-us-agents-description"
            placeholderText="Description"
            inputValue={formData?.["contact-us-agents-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Multi Agent Contacts */}
          <RepeatableMultipleInputStackFilds
            stateDetails={formData}
            isFetching={isFetching}
            allFilesResponse={allFilesResponse}
            labelText="Agents Contact"
            fieldId="contact-us-agents-contacts"
            fieldKey="contact-us-agents-contacts"
            searchValue={searchValue}
            selectedFileType={selectedFileType}
            adminRole={adminRole}
            permissionsList={permissionsList}
            addMultiValueRepeaterChange={addMultiValueRepeaterChange}
            removeMultiValueRepeaterChange={removeMultiValueRepeaterChange}
            updateMultiValueRepeaterChange={updateMultiValueRepeaterChange}
            translateField={true}
            extraContainerClasses="mt-5"
            filedStructure={["TEXT", "TEXT", "TEXT", "TEXT", "TEXT", "TEXT"]}
            dataStructure={{
              category: "",
              name: "",
              phone: "",
              fax: "",
              email: "",
              web: "",
            }}
            placeholderTexts={[
              "Category",
              "Name",
              "Phone",
              "Fax",
              "Email",
              "Website",
            ]}
            hideStatus={[
              true,
              true,
              isHideInOtherLanguages,
              isHideInOtherLanguages,
              isHideInOtherLanguages,
              isHideInOtherLanguages,
            ]}
            extraInfos={[
              "Category",
              "Agent Name",
              "Agent Phone Number",
              "Agent Fax",
              "Agent Email",
              "Agent Website",
            ]}
            colorGrade={colorGrade}
            extraContainerClasses="mt-5"
          />
        </>
      )}
    </>
  );
};

export default ContactUsCMSForm;
